import {
  GET_CLAIM_INFORMATION_TABLE,
  GET_CLAIM_INFORMATION_TABLE_ERROR,
  GET_CLAIM_INFORMATION_TABLE_SUCCESS,
  GET_ENCRYPT_CLAIM,
  GET_ENCRYPT_CLAIM_ERROR,
  GET_ENCRYPT_CLAIM_SUCCESS
} from './ClaimsReceivedChartSection.actions'

const claimListState = {
  error: undefined,
  loading: true,
  gridData: [],
  csvStructure: [],
  encrypt: '',
  loadingSpinner: false,
  errorEncrypt: undefined,
  hasData: false
}

/**
 * The claim ListReducer .
 */
const claimTableReducer = (state = claimListState, { payload, type }) => {
  switch (type) {
    case GET_CLAIM_INFORMATION_TABLE: {
      return { ...state, loading: true }
    }
    case GET_CLAIM_INFORMATION_TABLE_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_CLAIM_INFORMATION_TABLE_SUCCESS: {
      return {
        ...state,
        loading: false,
        gridData: payload.gridData,
        excelData: payload.excelData,
        hasData: payload.hasData
      }
    }
    case GET_ENCRYPT_CLAIM: {
      return { ...state, loadingSpinner: true }
    }
    case GET_ENCRYPT_CLAIM_SUCCESS: {
      return { ...state, loadingSpinner: false, encrypt: payload.encrypt }
    }
    case GET_ENCRYPT_CLAIM_ERROR: {
      return { ...state, loadingSpinner: false, errorEncrypt: payload.error }
    }
    default: {
      return state
    }
  }
}

export default claimTableReducer
